import { useMutation } from '@tanstack/react-query';
import CustomAxios from '../../../utility/customAxios';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';
import { AxiosError } from 'axios';
import { TaskTemplate } from '../../../types/TaskTemplate';
import { mutationKeys } from '../mutationKeys';

export const updateTaskTemplate = async (uuid: string | undefined, formData: TaskTemplate) => {
  if (!uuid) return null;

  const response = await CustomAxios.put(`task_templates/${uuid}`, formData);
  const { data } = response;
  return data;
};
interface UseUpdateTaskTemplateFormProps {
  uuid?: string;
  onSuccessCallback: () => void;
}
export function useUpdateTaskTemplate({ uuid, onSuccessCallback }: UseUpdateTaskTemplateFormProps) {
  return useMutation({
    mutationKey: [mutationKeys.updateTaskTemplate],
    mutationFn: (formData: TaskTemplate) => updateTaskTemplate(uuid, formData),
    onSuccess: (data: TaskTemplate) => {
      // fetch again after create
      queryClient.invalidateQueries({ queryKey: [queryKeys.allTaskTemplates, data.uuid] });

      // call success
      onSuccessCallback();
    },
    onError: (err: AxiosError) => {
      if (err?.response?.status === 400) {
        const taskTemplate: TaskTemplate = err.response.data as TaskTemplate;
        queryClient.setQueryData([queryKeys.allTaskTemplates, taskTemplate.uuid], taskTemplate);
      }
    },
  });
}
